import {createFileRoute} from '@tanstack/react-router';

import ConfirmAccount from '@/anonymous/views/ConfirmAccount';

export const Route = createFileRoute('/(anonymous)/confirm-account')({
  component: ConfirmAccount
});
